import { parseSpq } from "../survey/clirnetSurvey/index.js";

function tryParse(str) {
  try { return JSON.parse(str); } catch { return null; }
}

function unwrap(data) {
  let p = data;
  if (typeof p === "string") {
    const v = tryParse(p);
    if (v == null) return null;
    p = v;
  }
  if (p && typeof p.data === "string") {
    const inner = tryParse(p.data);
    if (inner && typeof inner === "object") p = inner;
  }
  return p;
}

export function normalizeQnaList(data) {
  const p = unwrap(data);
  if (p == null) return null;

  const list = Array.isArray(p) ? p : Array.isArray(p.data) ? p.data : null;
  if (!list) return null;

  return list
    .filter((q) => q && typeof q === "object" && (typeof q.id === "string" || typeof q.id === "number"))
    .map((q) => ({
      ...q,
      id: String(q.id),
      question: typeof q.question === "string" ? q.question : "",
      isApproved: q.isApproved === true,
      firstName: typeof q.firstName === "string" ? q.firstName : typeof q.first_name === "string" ? q.first_name : "",
      lastName: typeof q.lastName === "string" ? q.lastName : typeof q.last_name === "string" ? q.last_name : "",
      status: typeof q.status === "number" ? q.status : undefined,
    }));
}

function normalizePollItem(p) {
  if (!p || typeof p !== "object") return null;

  const numericId = p.id;
  if (numericId == null) return null;

  if (typeof p.category === "string") {
    const cat = p.category.trim().toLowerCase();
    if (cat !== "poll" && cat !== "interactive" && cat !== "survey") return null;

    const rawData = p.data && typeof p.data === "object" && !Array.isArray(p.data) ? p.data : null;
    if (!rawData) return null;

    const keys = Object.keys(rawData).filter((k) => /^question\d+$/i.test(k));
    if (!keys.length) return null;

    const hasQ = keys.some((k) => rawData[k] && typeof rawData[k] === "object" && typeof rawData[k].question === "string");
    if (!hasQ) return null;

    const isApproved = p.isApproved === true;
    const showresult = p.showresult === true;
    const isShuffle = p.is_shuffle === 1 || p.is_shuffle === true ? 1 : 0;
    const createdAt = typeof p.createdAt === "string" ? p.createdAt : typeof p.timestamp === "number" ? new Date(p.timestamp * 1000).toISOString() : new Date().toISOString();

    const base = {
      id: numericId,
      title: typeof p.title === "string" ? p.title : "",
      description: typeof p.description === "string" ? p.description : "",
      category: cat,
      image: typeof p.image === "string" ? p.image : "",
      points: typeof p.points === "number" ? p.points : Number(p.points) || 0,
      points_on_approval: typeof p.points_on_approval === "number" ? p.points_on_approval : Number(p.points_on_approval) || 0,
      duration: p.duration != null ? String(p.duration) : "10",
      question_count: typeof p.question_count === "number" ? p.question_count : keys.length,
      is_shuffle: isShuffle,
      is_shuffle_bool: isShuffle === 1,
      isApproved,
      showresult,
      createdAt,
      _raw: p,
    };

    if (cat === "interactive") {
      let opts = [];
      let qText = base.title;
      const firstKey = keys.slice().sort()[0];
      const first = firstKey ? rawData[firstKey] : null;

      if (first && typeof first === "object") {
        if (typeof first.question === "string" && first.question.trim()) {
          qText = first.question.replace(/<[^>]*>/g, "").trim() || qText;
        }
        if (Array.isArray(first.options) && first.options.length) {
          opts = first.options.map((o, i) => {
            if (!o || typeof o !== "object") return null;
            const label = typeof o.label === "string" ? o.label : typeof o.text === "string" ? o.text : String(o.value ?? `Option ${i + 1}`);
            const oid = typeof o.option_id === "string" ? o.option_id : typeof o.id === "string" ? o.id : `opt_${o.value != null ? String(o.value) : String(i + 1)}`;
            const correct = o.isCorrect === true || o.is_correct === true || o.correct === true || o.isCorrect === 1 || o.is_correct === 1;
            return { option_id: String(oid), text: label, isCorrect: correct, voteCount: typeof o.voteCount === "number" ? o.voteCount : 0 };
          }).filter(Boolean);
        }
      }

      const finalOpts = Array.isArray(p.options) && p.options.length ? p.options : opts;
      const finalQ = qText !== base.title ? qText : typeof p.question === "string" && p.question.trim() ? p.question : qText;
      const timer = typeof p.duration === "string" ? Number(p.duration) || 20 : typeof p.duration === "number" && p.duration > 0 ? p.duration : 20;

      return {
        type: "interactive-quiz",
        id: numericId,
        category: "interactive",
        question: finalQ,
        data: rawData,
        timer,
        showAns: p.showAns === true,
        options: finalOpts,
        ...base,
      };
    }

    if (cat === "survey") {
      return { type: "survey", id: numericId, category: "survey", data: rawData, pollType: p.pollType === "popup" ? "popup" : "section", ...base };
    }

    return { type: "poll", id: numericId, category: "poll", data: rawData, pollType: p.pollType === "popup" ? "popup" : "section", ...base };
  }

  const type = typeof p.type === "string" ? p.type.trim() : "";
  const isApproved = p.isApproved === true;
  const showresult = p.showresult === true;
  const createdAt = typeof p.createdAt === "string" ? p.createdAt : new Date().toISOString();

  if (type === "interactive-quiz" || type === "interactive") {
    if (p.id == null) return null;
    const opts = Array.isArray(p.options)
      ? p.options.filter((o) => o && typeof o === "object" && typeof o.option_id === "string").map((o) => ({
          option_id: o.option_id,
          text: typeof o.text === "string" ? o.text : "",
          isCorrect: o.isCorrect === true,
          voteCount: typeof o.voteCount === "number" ? o.voteCount : 0,
        }))
      : [];
    const out = { type: "interactive-quiz", id: p.id, question: typeof p.question === "string" ? p.question : "", timer: typeof p.timer === "number" && p.timer > 0 ? p.timer : 20, isApproved, showresult, showAns: p.showAns === true, options: opts, createdAt };
    if (typeof p.category === "string") out.category = p.category;
    return out;
  }

  if (type === "poll" || type === "survey") {
    if (p.id == null) return null;
    return { type, category: type, id: p.id, title: typeof p.title === "string" ? p.title : "", description: typeof p.description === "string" ? p.description : "", data: p.data && typeof p.data === "object" ? p.data : {}, pollType: p.pollType === "popup" ? "popup" : "section", isApproved, showresult, createdAt, _raw: p };
  }

  if (type === "clirnetSurvey" || type === "SurveyJs") {
    if (p.id == null) return null;
    const out = { type, id: p.id, pollType: p.pollType === "popup" ? "popup" : "section", isApproved, showresult, createdAt };
    if (type === "clirnetSurvey") {
      out.spq = parseSpq(p.spq) ?? {};
      if (typeof p.category === "string") out.category = p.category;
    } else {
      out.question = p.question && typeof p.question === "object" ? p.question : {};
      if (typeof p.category === "string") out.category = p.category;
    }
    return out;
  }

  return null;
}

export function normalizePollList(data) {
  const p = unwrap(data);
  if (p == null) return null;
  if (Array.isArray(p.polls)) return p.polls.map(normalizePollItem).filter(Boolean);
  if (Array.isArray(p.data)) return p.data.map(normalizePollItem).filter(Boolean);
  if (Array.isArray(p)) return p.map(normalizePollItem).filter(Boolean);
  return null;
}

// comment_id: the comment API's id for an HCP chat message (sessions/submit/session/comment
// data.comment_id). As { comment_id } to spread into a message, or {} when there is none
// (messages from before it was added) or it is unusable.
function pickCommentId(m) {
  const id = m?.comment_id;
  const ok = (typeof id === "number" && Number.isFinite(id)) || (typeof id === "string" && id !== "");
  return ok ? { comment_id: id } : {};
}

// Admin replies carry a snapshot of the approved message they answer:
// { messageId, userId, name, message, comment_id }. userId = the HCP who wrote the quoted
// message ("" on replies published before it was added); comment_id = that message's
// comment_id, when it had one. Anything malformed is dropped (no quote).
function normalizeReplyTo(r) {
  if (!r || typeof r !== "object" || typeof r.messageId !== "string") return null;
  return {
    messageId: r.messageId,
    userId: typeof r.userId === "string" ? r.userId : "",
    name: typeof r.name === "string" ? r.name : "",
    message: typeof r.message === "string" ? r.message : "",
    ...pickCommentId(r),
  };
}

// users channel: one HCP viewer's meeting status, { clientID, name, joinMeeting }. The viewer
// publishes it on opening the page (joinMeeting false); the admin publishes it to join (true)
// or remove (false) that one viewer. Without a clientID it is about nobody: dropped.
export function normalizeUserChannelMessage(data) {
  const p = unwrap(data);
  if (!p || typeof p !== "object" || typeof p.clientID !== "string" || !p.clientID) return null;
  return {
    clientID: p.clientID,
    name: typeof p.name === "string" ? p.name : "",
    joinMeeting: p.joinMeeting === true,
  };
}

export function normalizeChatMessage(data) {
  const p = unwrap(data);
  if (p == null) return null;
  let m = null;
  if (p && typeof p === "object" && typeof p.messageId === "string") {
    m = p;
  } else if (p && typeof p === "object" && p.message && typeof p.message === "object" && typeof p.message.messageId === "string") {
    m = p.message;
  } else if (data && typeof data === "object" && data.message && typeof data.message === "object" && typeof data.message.messageId === "string") {
    m = data.message;
  } else {
    return null;
  }
  return {
    messageId: m.messageId,
    userId: typeof m.userId === "string" ? m.userId : "",
    name: typeof m.name === "string" ? m.name : "",
    image: typeof m.image === "string" ? m.image : null,
    sessionId: m.sessionId != null ? String(m.sessionId) : "",
    message: typeof m.message === "string" ? m.message : "",
    isApproved: m.isApproved === true,
    pinned: m.pinned === true,
    createdAt: typeof m.createdAt === "string" ? m.createdAt : new Date().toISOString(),
    ...pickCommentId(m),
  };
}

export function normalizeChatSentList(data) {
  const p = unwrap(data);
  if (p == null) return null;
  let arr = null;
  if (Array.isArray(p)) {
    arr = p;
  } else if (p && typeof p === "object" && Array.isArray(p.data)) {
    arr = p.data;
  } else if (p && typeof p === "object" && Array.isArray(p.chat)) {
    arr = p.chat;
  } else {
    return null;
  }
  return arr
    .filter((m) => m && typeof m === "object" && typeof m.messageId === "string")
    .map((m) => {
      const replyTo = normalizeReplyTo(m.replyTo);
      return {
        messageId: m.messageId,
        userId: typeof m.userId === "string" ? m.userId : "",
        name: typeof m.name === "string" ? m.name : "",
        image: typeof m.image === "string" ? m.image : null,
        sessionId: m.sessionId != null ? String(m.sessionId) : "",
        message: typeof m.message === "string" ? m.message : "",
        isApproved: true,
        pinned: m.pinned === true,
        createdAt: typeof m.createdAt === "string" ? m.createdAt : new Date().toISOString(),
        ...pickCommentId(m),
        ...(replyTo ? { replyTo } : {}),
      };
    });
}

function ensureRawCmeShape(raw) {
  if (!raw || typeof raw !== "object") return raw;
  const data = raw.data && typeof raw.data === "object" ? raw.data : {};
  const detail = data.detail && typeof data.detail === "object" ? data.detail : {};
  return {
    ...raw,
    data: {
      ...data,
      detail: raw.status != null ? { ...detail, status: raw.status } : detail,
      hosting: data.hosting && typeof data.hosting === "object" ? data.hosting : {},
      streaming: data.streaming && typeof data.streaming === "object" ? data.streaming : {},
      setting: data.setting && typeof data.setting === "object" ? data.setting : {},
    },
  };
}

export function normalizeSessionDetails(raw) {
  if (!raw || typeof raw !== "object") return null;
  const shaped = ensureRawCmeShape(raw);
  const detail = shaped.data.detail;
  const setting = shaped.data.setting;

  const statusNum = Number(detail.status);
  const status = Number.isFinite(statusNum) ? statusNum : detail.status;

  const nav = setting.navbar && typeof setting.navbar === "object" ? setting.navbar : {};
  const sub = setting.subNavbar && typeof setting.subNavbar === "object" ? setting.subNavbar : {};
  const eng = setting.engagement && typeof setting.engagement === "object" ? setting.engagement : {};

  const { status: _flatStatus, ...rest } = shaped;

  return {
    ...rest,
    data: {
      ...shaped.data,
      detail: {
        ...detail,
        status,
        specialities: Array.isArray(detail.specialities) ? detail.specialities : [],
        speakers: Array.isArray(detail.speakers) ? detail.speakers : [],
      },
      setting: {
        ...setting,
        navbar: { ...nav, isNavbarOpen: nav.isNavbarOpen !== false, isLogoVisible: nav.isLogoVisible !== false, isTitleVisible: nav.isTitleVisible !== false, isExitButtonVisible: nav.isExitButtonVisible !== false },
        subNavbar: { ...sub, isSubNavbarVisible: sub.isSubNavbarVisible !== false, isDescriptionVisible: sub.isDescriptionVisible !== false, isSpecialitiesVisible: sub.isSpecialitiesVisible !== false, isSessionTimeVisible: sub.isSessionTimeVisible !== false },
        engagement: { ...eng, isEngagementVisible: eng.isEngagementVisible !== false, isChatVisible: eng.isChatVisible !== false, isQNAVisible: eng.isQNAVisible !== false, isPollsVisible: eng.isPollsVisible !== false },
        isBannerVisible: setting.isBannerVisible !== false,
        isVideoPlayerVisible: setting.isVideoPlayerVisible !== false,
        isSpeakersVisible: setting.isSpeakersVisible !== false,
        isFooterVisible: setting.isFooterVisible !== false,
      },
    },
  };
}
